import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';

import * as ROUTES from '#client/constants/routes';

import CarouselCard from '../CarouselCard/CarouselCard';

function VeloLicensesCard() {
  const { businessEntityUuid } = useBusinessEntity();
  const href = `${ROUTES.VELO_GUIDE_COMPANY.replace('[businessEntityUuid]', businessEntityUuid)}?topic=questions-about-licenses`;

  return (
    <CarouselCard
      imageSrc="/s2/raster/bakery-pad-pen-carousel.png"
      imageAltId="dashboard.carousel.card.veloLicenses.imageAlt"
      titleId="dashboard.carousel.card.veloLicenses.title"
      subtitleId="dashboard.carousel.card.veloLicenses.subTitle"
      href={href}
      elementName="carousel_velo_licenses_link"
    />
  );
}

export default VeloLicensesCard;
